import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { WebsiteConnection } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class WebsiteConnectionService extends TmsWebBaseEditCreateService<WebsiteConnection, WebsiteConnection> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('WebsiteConnection', $localize`Website Connection`);
  }

  getForSellingCompany(id: string): Observable<WebsiteConnection[]> {
    return this.httpService.get<WebsiteConnection[]>(`${this.apiUrl}/GetForSellingCompany?id=${id}`);
  }
}
